import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const RootStyled = styled(Box)({
  border: '1px solid #B0B0B0',
  padding: 32,
  borderRadius: '8px',
  margin: '54px 0 20px 0',
});

export const FieldContainer = styled(Box)({
  margin: '15px 0',
  width: '90%',
});

export const FormTitle = styled(Typography)({
  marginBottom: '20px',
});
